<template>
  <vue-apex-charts
    type="radialBar"
    :height="height"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'GraficoTotalizador',
  components: {
    VueApexCharts,
  },
  props: {
    height: {
      type: Number,
      default: 150,
    },
    valor: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    cores: {
      type: Array,
      required: true,
    },
  },
  computed: {
    series() {
      return this.valor
    },
    chartOptions() {
      return {
        colors: this.cores,
        chart: {
          height: this.height,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: true,
                fontWeight: 700,
                fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
                color: getComputedStyle(document.documentElement).getPropertyValue('--chart-text-color').trim() || '#6e6b7b',
              },
            },
          },
        },
        labels: [this.label],
      }
    },
  },
}
</script>
